import { create } from "zustand";
import { Tenant } from "@/api/tenant.api";
import store from "store2";
import isNil from "lodash.isnil";

export const SELECTED_TENANT_STORAGE_KEY = "exibra/selected-tenant";

export interface TenantState {
    /** Available tenants for the user */
    tenants: Tenant[];
    /** The currently selected tenant */
    selectedTenant?: Tenant;
    /** Loading state for tenant operations */
    loading: boolean;
}

export interface TenantActions {
    /** Sets the available tenants */
    setTenants: (tenants: Tenant[]) => void;
    /** Selects a tenant and stores it in local storage */
    selectTenant: (tenant?: Tenant) => void;
    /** Sets the loading state */
    setLoading: (loading: boolean) => void;
    /** Clears all tenant data */
    clearTenantData: () => void;
}

export const useTenantStore = create<TenantState & TenantActions>()((set) => ({
    tenants: [],
    selectedTenant: store.get(SELECTED_TENANT_STORAGE_KEY),
    loading: false,

    setTenants: (tenants) => {
        set({ tenants });
    },

    selectTenant: (tenant) => {
        if (isNil(tenant)) {
            store.remove(SELECTED_TENANT_STORAGE_KEY);
        } else {
            store.set(SELECTED_TENANT_STORAGE_KEY, tenant);
        }

        set({ selectedTenant: tenant });
    },

    setLoading: (loading) => {
        set({ loading });
    },

    clearTenantData: () => {
        store.remove(SELECTED_TENANT_STORAGE_KEY);
        set({ tenants: [], selectedTenant: undefined });
    },
}));
